import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useUserSubjects } from "utils/hooks/useUserSubjects";
import Loading from "components/Loading/Loading";

const TutoringRedirect = () => {
  const navigate = useNavigate();
  const { userSubjects } = useUserSubjects();

  const getTutoringUrl = () => {
    const subject = userSubjects?.find(subject => subject.subject?.slug);
    const { slug } = subject?.subject ?? {};

    return slug;
  };

  useEffect(() => {
    if (!userSubjects) return;

    const redirectUrl = getTutoringUrl();
    if (redirectUrl) {
      navigate(redirectUrl);
    } else {
      navigate("/");
    }
  }, [userSubjects]);

  return <Loading />;
};

export default TutoringRedirect;
